module.exports = __webpack_public_path__ + "media/facial-recognition/circles-group-a4c6612d.svg";